import React, { useState } from "react";
// import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Modal, PageHeader } from 'antd';
import { faArrowLeft, faArrowRightLong, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Card from 'react-bootstrap/Card';
import { Tabs } from "antd";
import { Link, NavLink, useNavigate } from "react-router-dom/dist";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import CompanyMeetingIcon from "../../assets/images/icons/company_meeting_icon.png"
import EVotingIcon from "../../assets/images/icons/evoting_icon.png"
import DirectorshipIcon from "../../assets/images/icons/directorship_icon.png"
import AdvisoryServiceIcon from "../../assets/images/icons/advisory_service_icon.png"
import CalendarIcon from "../../assets/images/icons/AGM_EOGM_Calendar.png"
import AnnouncementIcon from "../../assets/images/icons/Company_Announcement.png"
import { Col, Container, Row } from "react-bootstrap";
import InnerHeading from "../components/InnerHeading/InnerHeading";

const localizer = momentLocalizer(moment);
const { TabPane } = Tabs;

const CompanyMeetingnAnnouncement = () => {

    const navigate = useNavigate();




    let headerData = [{
        name: "Company Meeting & Announcements",
        route: "/E-service/CompanyMeeting&Announcements",
        imgSrc: CompanyMeetingIcon
    }, {
        name: "E-Voting",
        route: "/E-service/E-Voting",
        imgSrc: EVotingIcon
    }
        //     , {
        //     name: "Directorship",
        //     route: "/E-service/Directorship",
        //     imgSrc: DirectorshipIcon
        // }
        //     , {
        //     name: "Advisory Services",
        //     route: "/E-service/AdvisoryServices",
        //     imgSrc: AdvisoryServiceIcon
        // }
    ]

    return (
        <>




            <PageHeaderWithRoutes tabs={headerData} heading="E-Services" desc="Discover a range of e-services such as the AGM/EOGM Calendar, e-voting options, directorship resources, and advisory services. These tools are crafted to streamline governance tasks and empower informed decision-making for shareholders and issuers alike." />



            <div className="content_wrap">


                <div className="mettingnAnn">
                    <div className='container'>
                        <div className="cards_wrap">
                            <Container>
                                <Row>
                                    <InnerHeading heading="Company Meeting & Announcements" text="Stay updated with the latest company meeting schedules and critical announcements." />

                                    <Col lg={5}>
                                        <div className="box" >
                                            <h5 className="bold text-center">AGM/EOGM Calendar</h5>
                                            <p>The AGM/EOGM Calendar keeps shareholders informed about scheduled annual and extraordinary general meetings (AGM/EOGM).</p>
                                            <Link target={"_blank"} to="https://dps.psx.com.pk/calendar">
                                                <Card className="cards">
                                                    <img width="100" src={CalendarIcon} />
                                                    <h5 className="text-center">AGM/EOGM
                                                        Calendar</h5>
                                                    Click here to view

                                                </Card>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col lg={2}></Col>
                                    <Col lg={5}>
                                        <div className="box">
                                            <h5 className="bold text-center">Company Announcements</h5>
                                            <p>Access essential company announcements to stay abreast of all significant corporate developments.</p>
                                            <Link target={"_blank"} to="https://dps.psx.com.pk/announcements/companies">
                                                <Card className="cards">
                                                    <img width="100" src={AnnouncementIcon} />
                                                    <h5 className="text-center">Company
                                                        Announcements</h5>
                                                    Click here to view
                                                </Card>
                                            </Link>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>

                        </div>

                    </div>




                </div>
            </div >


        </>
    );
};

export default CompanyMeetingnAnnouncement;
